require('./helpers/bundle-manifest').register(JSON.parse("{\"flVV4\":\"game.8e6191c5.js\",\"3b4lj\":\"game-over-sprite.dd932fed.png\"}"));